<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="subheader with-padding flgrow">
                <div class="row align-items-center">
                    <div class="col-6 col-lg-3">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <div class="input-group">
                                    <input class="form-control" type="text" name="searchTerm"
                                        placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="searchTerm"
                                        autocomplete="off" (keyup.enter)="onSearchFilter()" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                                                <em class="fa fa-search"></em>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="ml-2 advanced-search-box">
                                <button type="button" class="btn btn-primary px-2-5" (click)="onSearch()"
                                    aria-label="Center Align">
                                    <em class="fa fa-search-plus" aria-hidden="true"></em>
                                </button>
                                <div class="searchbox card fix lt" *ngIf="isAdvanceSearch">
                                    <div class="form-row mt-3 mb-3">
                                        <div class="col">
                                            <div class="custom-control custom-checkbox mt-25">
                                                <input class="custom-control-input" type="checkbox"
                                                    [checked]="companyShow" id="customCheck1"
                                                    (change)="changeCustomerType($event)" />
                                                <label class="custom-control-label" style="line-height: 25px;"
                                                    for="customCheck1" translate>lblCompany</label>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <label for="template-customerName" translate>lblAccountName </label>
                                            <div class='lbl-info'>
                                                <input type="text" id="template-customerName" name="customerName"
                                                    [(ngModel)]="accountService.accountListRequest.customerName"
                                                    class="form-control" maxlength="100">
                                            </div>
                                        </div>
                                        <div class="col">
                                            <label for="template-customerNo" translate>lblAccountNo</label>
                                            <input type="text" id="template-customerNo" name="customerNo"
                                                [(ngModel)]="accountService.accountListRequest.customerNo"
                                                class="form-control" />

                                        </div>

                                    </div>
                                    
                                    <hr />
                                    <div class="row">
                                        <div class="col text-right">
                                            <button type="submit" (click)="OpenSaveSearchModal(SaveSearchContent)"
                                                aria-label="Center Align" class="btn btn-primary mr-sm-3"
                                                translate>lblSaveFilter
                                            </button>
                                            <button type="submit" (click)="onApplyFilter()"
                                                class="btn btn-primary mr-sm-3" translate>lblApply
                                            </button>
                                            <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-3"
                                                translate>lblReset
                                            </button>
                                            <button (click)="onClose()" class="btn btn-outline-tertiary"
                                                translate>lblClose
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto pl-0">
                        <button type="submit" (click)="OpenSavedSearchListPopup()"
                            class="btn btn-primary" translate aria-label="Center Align">lblSavedFilters</button>
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
                        <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                            (change)="StatusChange($event)">
                            <ng-option *ngFor="let status of StatusList" [value]="status.id">
                                {{status.value}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-6" *ngIf="IsDMS">
                        <ng-select placeholder="{{ 'lblDMSStatus' | translate }}" [(ngModel)]="selectedSync"
                            (change)="SyncChange($event)">
                            <ng-option *ngFor="let status of SyncList" [value]="status.id">
                                {{status.value}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-3 col-lg-3 ml-auto d-flex flex-sm-row flex-column justify-content-end align-items-center">
                        <div>
                            <button (click)="exportAsXLSX()" translate ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
                                aria-label="Center Align">
                                <img src="./../../../assets/images/excel.png" height="32" width="32"
                                    class="text-success" alt="" />
                            </button>
                            <button class="ml-2 btn btn-link icon-pdf" (click)="openPDF()" translate
                                ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
                              
                                <em class="far fa-file fa-2x"></em>
                                <span class="bdg">PDF</span>
                            </button>
                        </div>
                        <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
                            aria-label="Center Align">
                            <em class="fas fa-sync fa-lg"></em>
                        </a>
                        <button type="button" type="reset" class="ml-2 add-button btn btn-primary"
                            aria-label="Center Align" *ngIf="IsAddAccount && userRoleRightsDetails.canAdd"
                            (click)="onAdd()" translate>lblAddAccount
                        </button>
                    </div>
                </div>

            </div>
            <div class="container prel">
                <div class="row">
                    <div class="c12">
                        <div class="card mb-3 scrollbar">
                            <div class="card-header d-flex justify-content-between" translate>
                                lblAccounts
                                <div class="font16 fontbold">
                                    <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                                    {{totalCount}}
                                    &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                                </div>
                            </div>
                            <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                <table class="tablest1">
                                    <thead>
                                        <tr>
                                            <th style="width:55px" scope="col" translate>#</th>
                                            <th scope="col" sortable="customerType" translate>
                                                lblAccountNo</th>
                                            <th scope="col" sortable="customerName" translate>
                                                lblAccountName</th>
                                            <th scope="col" sortable="pincode" translate>
                                                lblAddress</th>
                                            <th scope="col" sortable="noOfVehicle" 
                                                class="text-center" translate>lblContacts</th>
                                            <th scope="col" translate>lblSource</th>
                                            <th scope="col" style="width:50px" sortable="updatedDate"
                                                 translate>lblUpdatedDate</th>
                                            <th scope="col" style="width:50px" sortable="dmsSyncDate"
                                                translate *ngIf="IsDMS">lbllastSyncdate</th>
                                            <th class="text-center" scope="col" translate>lblActive</th>
                                            <th scope="col" translate class="text-center"
                                                >lblAction</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="accountsList?.length>0; else load_NotFound_Template">
                                            <tr *ngFor="let item of accountsList; let i=index">
                                                <td>{{ item.rowNumber }}</td>
                                                <td>
                                                    <ngb-highlight [result]="item.accountNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight class="fs-14px semibold lh-18px d-block"
                                                        [result]="item.accountName">
                                                    </ngb-highlight>
                                                    <div class="d-flex align-items-center mt-1 fs-12px lh-16px"
                                                        *ngIf="item.mobileNo">
                                                        <em _ngcontent-xdg-c220=""
                                                            class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                                        <span class="fs-12px"
                                                            *ngIf="item.mobileCode">{{item.mobileCode}}-</span>
                                                        <ngb-highlight class="fs-12px" [result]="item.mobileNo">
                                                        </ngb-highlight>
                                                    </div>
                                                    <div class="d-flex align-items-center" *ngIf="item.email">
                                                        <em _ngcontent-xdg-c220=""
                                                            class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                                                        <ngb-highlight class="fs-12px" [result]="item.email">
                                                        </ngb-highlight>
                                                    </div>
                                                </td>

                                                <td>
                                                    <ngb-highlight [result]="item.addressLine1">
                                                    </ngb-highlight>
                                                    <div class="d-flex align-items-center mt-1 fs-12px lh-16px">
                                                        <ngb-highlight class="fs-12px mr-2" [result]="item.pincode">
                                                        </ngb-highlight>
                                                        <ngb-highlight class="fs-12px" [result]="item.city">
                                                        </ngb-highlight>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <ngb-highlight class="fs-12px" [result]="item.country">
                                                        </ngb-highlight>
                                                    </div>
                                                </td>
                                                <td class="text-center">
                                                    <ngb-highlight [result]="item.NoOfAccounts">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight
                                                        [ngClass]="item.sourceType ? 'flmid sourceBox rounded-0 justify-content-center' : ''"
                                                        [result]="item.sourceType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    {{ item.updatedDate | date:'short'}}
                                                </td>
                                                <td *ngIf="IsDMS">
                                                    {{ item.dmsSyncDate | date:'short'}}
                                                </td>
                                                <td class="text-center">
                                                    <em class="fas fa-check" *ngIf="item.isActive == true"></em>
                                                    <em class="fas fa-close" *ngIf="item.isActive == false"></em>
                                                </td>

                                                <td class="nowrap text-center"
                                                    *ngIf="!fromVehicleScreen">
                                                    <ng-container *ngIf="integrationWithDMS">
                                                        <a class="btn btn-ico"
                                                            ngbTooltip="{{ 'lblSyncToDMS' | translate }}"
                                                            tooltipClass="custom-revert"
                                                            [class.invisible]="item.dmsSyncStatus != 0"
                                                            (click)="onSyncToDms(item.id)">
                                                            <em class="fas fa-sync fa-lg  "></em>
                                                        </a>
                                                        <span class="ico-div"
                                                            [class.invisible]="item.dmsSyncStatus != 0"></span>
                                                        <a class="btn btn-ico"
                                                            ngbTooltip="{{ 'lblDMSSyncFailedlog' | translate }}"
                                                            tooltipClass="custom-revert"
                                                            [class.invisible]="item.dmsSyncStatus != 0"
                                                            (click)="viewException(item.id)">
                                                            <em class="fas fa-clipboard-list fa-lg  "></em>
                                                        </a>
                                                        <span class="ico-div"
                                                            [class.invisible]="item.dmsSyncStatus != 0"></span>
                                                    </ng-container>
                                                    <a class="btn btn-ico" ngbTooltip="View"
                                                        tooltipClass="custom-revert"
                                                        *ngIf="userRoleRightsDetails.canView" (click)="onView(item.accountId)">
                                                        <em class="fa fa-eye fa-lg"></em>
                                                    </a>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_NotFound_Template>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer">
                              
                            </div>

                            <div class="p-3 bg-light" *ngIf="selectedCustomerId">
                                <div class="row">
                                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                                        <button type="submit" *ngIf="selectedCustomerId" class="btn btn-primary mr-sm-2"
                                            translate (click)="selectedCustomer();"
                                            aria-label="Center Align">lblSelectCustomer</button>
                                    </div>
                                </div>
                            </div>

                            <div style="display: none; margin-top: 600px;">
                                <div class="container">
                                    <div class="row mb-15">
                                        <div class="col-12">
                                            <div class="row pl-5 pr-5 pt-5 pb-5">
                                                <div class="col-md-5">
                                                    <img class="brand" src="assets/images/autofacets.png"
                                                        onError="this.onerror=null; this.src='../../../assets/images/no-image-icon.png'"
                                                        height="70" style="width:300px" alt="">
                                                </div>

                                                <div class="col-md-7">
                                                    <div class="Invoice_title" style="float: left;">
                                                        <p class="font-weight-bold"
                                                            style="font-size:24px; color: black;">Customer Data
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <table class="table" id="accountPDF">
                                    <thead class="">
                                        <tr class="table-primary" style="font-size: large">
                                            <th scope="col" style="width:5%" translate style="font-weight: bold;">#</th>
                                            <th scope="col" style="width:9%" translate style="font-weight: bold;">
                                                lblAccountNo</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblAccountName</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblMobile</th>
                                            <th scope="col" style="width:17%" translate style="font-weight: bold;">
                                                lblEmail</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblSource</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblCity</th>
                                            <th scope="col" style="width:10%" translate style="font-weight: bold;">
                                                lblCountry</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="accountListPDF?.length>0; else load_NotFound_Template">
                                            <tr *ngFor="let item of accountListPDF; let i=index">
                                                <td>{{ i+1 }}</td>
                                                <td>
                                                    <ngb-highlight [result]="item.accountNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.accountName">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <span *ngIf="item.mobileCode">+{{item.mobileCode}}</span>
                                                    <ngb-highlight [result]="item.mobileNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.email">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.sourceType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.city">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.country">
                                                    </ngb-highlight>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_NotFound_Template>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>